<template>

    <v-card class="pb-4">
      <!-- Agent cards -->
      <v-card-text>
        <template v-if="agentItems.length > 0">
          <v-row class="pa-0 ma-0">
            <v-col
              v-for="(agent, index) in agentItems"
              :key="`agent-${index}`"
              :class="{ active: agent.id === selectedAgent.id }"
              cols="12">
              <agent-card
                  :agent="agent"
                  v-on:itemClicked="setSelectedAgent(agent)" />
            </v-col>
          </v-row>
        </template>

        <template v-else>
          (No agents)
        </template>
      </v-card-text>

      <!-- Actions -->
      <v-card-actions>
        <v-btn text color="primary" @click="emitCancel">
          Cancel
        </v-btn>
        <v-spacer />
        <v-btn color="primary" :disabled="!selectedAgent.id" @click="emitSelection">
          Copy Agent Info
        </v-btn>
      </v-card-actions>
    </v-card>

</template>

<script>
import AgentCard from '@/components/agents/AgentCard'

export default {
  name: 'AgentSelector',

  components: {
    AgentCard
  },

  data () {
    return {
      selectedAgent: {}
    }
  },

  props: {
    // Array of orders that contain receiving agent info
    agentData: {
      type: Array,
      default: null
    },
    activeSelected: {
      type: Object,
      default: null
    }
  },

  computed: {
    agentItems () {
      return this.$root.utils.uniqBy(this.agentData, 'receiving_agent_fa_license_number')
    }
  },

  beforeMount () {
    // Set the active selection (if provided)
    if (this.activeSelected) this.selectedAgent = this.activeSelected
  },

  methods: {
    emitCancel () {
      this.selectedAgent = {}
      this.$emit('canceled')
    },

    emitSelection () {
      this.$emit('selected', this.selectedAgent)
    },

    setSelectedAgent (agent) {
      this.selectedAgent = agent
    }
  }
}
</script>

<style>
  .active {
    border-radius: 4px;
    border: 2px solid #c9c9c9;
  }
</style>
